import React,{useState} from "react";
import { Container } from "react-bootstrap";
import AddDataSourceCardComponent from "../components/AddDataSourceCardComponent";
import {
  faDatabase,
  faFileCsv,
  faFileImport,
  faPlug,
} from "@fortawesome/free-solid-svg-icons";
import DataSourceCardContainer from "../components/DataSourceCardContainer";
import { Colors } from "../utils/style";
import { useTranslation } from 'react-i18next';
import { useStore } from "../store";

function DataSource() {
  const {t} = useTranslation('dataSource');

  const { userFilesNames, setUserFilesNames } = useStore();
  const [expandedFile, setExpandedFile] = useState<string | null>(null);
  const [selectedFileForVisualization, setSelectedFileForVisualization] = useState<string>("");
  return (
    <Container className="mt-4 mb-4">
      <div className="mb-5 mt-5">
        <h2 style={{ color: Colors.DARK_BLUE }}>
          {t("DataSource")}
        </h2>
      </div>
      <div
        style={{
          display: "flex",
          gap: "1rem",
          justifyContent: "space-between",
          marginBottom: "1rem",
        }}
      >
        <AddDataSourceCardComponent title={t("UploadFile")} icon={faFileImport} />
        {/* <AddDataSourceCardComponent
          title={t("ConnectDatabase")}
          icon={faDatabase}
        /> */}
        {/* <AddDataSourceCardComponent title={t("PluginStreams")} icon={faPlug} /> */}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <DataSourceCardContainer
          title={t("MyFiles")}
          icon={faFileCsv}
          items={userFilesNames || []}
          expandedFile={expandedFile} 
          setExpandedFile={setExpandedFile} 
          setSelectedFileForVisualization={setSelectedFileForVisualization}
        />
        {/* <DataSourceCardContainer
          title={t("MyDatabases")}
          icon={faDatabase}
          items={["Database 1 version 1", "Database 2", "Database 3"]}
        ></DataSourceCardContainer>
        <DataSourceCardContainer
          title={t("MyPluginStreams")}
          icon={faPlug}
          items={["Plugin Stream 1", "Plugin Stream 2", "Plugin Stream 3"]}
        ></DataSourceCardContainer> */}
      </div>
    </Container>
  );
}

export default DataSource;